exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-one-wrapper[data-v-4631810f] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.wrapper-charts[data-v-4631810f] {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n}\n#filter-charts[data-v-4631810f] {\n  margin-left: 2%;\n}\n.tab-two-wrapper[data-v-4631810f] {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n.sub-group[data-v-4631810f] {\n  width: 45%;\n}\n.wrapper-group[data-v-4631810f] {\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n.toogle-el[data-v-4631810f] {\n  display: none;\n}\n", ""]);

// exports
